/** Copy for the distributor table. */
export const DISTRIBUTOR_TABLE_CONFIG = {
  subDistributorBadge: 'Sub-distributor',
  subBadgePrefix: 'Sub of',
  expandRow: 'Expand sub-distributors',
  collapseRow: 'Collapse sub-distributors',
  expandAllToggle: 'Expand sub-distributors',

  // Must match the sort key in the API columnMap
  lastAccessColumn: 'Last access',
  lastAccessFallbackTooltip: 'No sign-ins recorded yet — showing the last activity date',
} as const;
